import React from 'react';
import { createRoot } from 'react-dom/client';
// Icon fonts are imported from the same packages whose JS glyphmaps are
// bundled, so webpack fingerprints the URL and the TTF can never drift out of
// sync with the glyphmap shipped in the JS bundle.
//
// react-native-paper v5 imports from `@react-native-vector-icons/material-design-icons`
// (web fontFamily "MaterialDesignIcons"). A few screens still import directly
// from the legacy `react-native-vector-icons/MaterialCommunityIcons` (web
// fontFamily "MaterialCommunityIcons" — the file basename, not the PostScript
// name; see Platform.select(web:) in the legacy package's createIconSet).
// Both must be registered.
import mdiFont from '@react-native-vector-icons/material-design-icons/fonts/MaterialDesignIcons.ttf';
import mciFont from 'react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf';
import App from '../App';

const fontFaceCss = `
  @font-face {
    font-family: 'MaterialDesignIcons';
    src: url(${mdiFont}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'MaterialCommunityIcons';
    src: url(${mciFont}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'Manrope-Regular';
    src: url(https://fonts.gstatic.com/s/manrope/v20/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk79FO_F.ttf) format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Manrope-Medium';
    src: url(https://fonts.gstatic.com/s/manrope/v20/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk7PFO_F.ttf) format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Manrope-SemiBold';
    src: url(https://fonts.gstatic.com/s/manrope/v20/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk4jE-_F.ttf) format('truetype');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Manrope-Bold';
    src: url(https://fonts.gstatic.com/s/manrope/v20/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk4aE-_F.ttf) format('truetype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Inter-Regular';
    src: url(https://fonts.gstatic.com/s/inter/v20/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuLyfMZg.ttf) format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Inter-Medium';
    src: url(https://fonts.gstatic.com/s/inter/v20/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuI6fMZg.ttf) format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
`;

const fontStyleEl = document.createElement('style');
fontStyleEl.appendChild(document.createTextNode(fontFaceCss));
document.head.appendChild(fontStyleEl);

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

createRoot(container).render(<App />);
